var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "ArrowClockwise",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-arrow-clockwise","viewBox":"0 0 260 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M121.3 0C54.4 0 0 56.1 0 125s54.3 124.9 121.2 125c3.2 0 6.2-1.7 7.8-4.5 1.6-2.8 1.6-6.4 0-9.2-1.6-2.8-4.6-4.6-7.8-4.5C63.9 231.7 17.7 184 17.7 125S64 18.3 121.3 18.3c43.7 0 81 27.8 96.3 67.1l-18.2-11c-2.7-1.8-6.3-2-9.1-.3-2.9 1.6-4.6 4.8-4.6 8.2.1 3.4 1.9 6.5 4.8 8l35.4 21.3c2.1 1.2 4.6 1.6 6.9.9 2.3-.7 4.3-2.3 5.4-4.5l20.7-39.6c1.6-2.9 1.5-6.4-.1-9.2-1.6-2.8-4.6-4.5-7.8-4.4-3.3 0-6.3 2-7.8 5L233.7 78C215.6 32.1 172 0 121.3 0z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/arrow-clockwise.svg